import { SizedBox } from '@/components/SizedBox'
import { TabPane, Tabs } from '@/components/Tabs'
import { useOrderListDividingStore } from '@/hooks/use-order-list-dividing'
import { useI18n } from 'i18n-utils'
import { exchangeSocketService, useAssetsStore, useChangeSymbol, useKlineStore, useQuoteStore, useResponsive } from 'store'
import { LazyLoadingComponent, Visible } from 'ui-components'
import { OrderList } from './OrderList'
import { TradeOrderer } from './Orderer'
import { Handicap } from './components/Handicap'
import { HandicapRealTimeTransaction } from './components/HandicapRealTimeTransaction'
import { KlinePanel } from './components/KlinePanel'
import { RealTimeTransaction } from './components/RealTimeTransaction'
import { SpotKline } from './components/SpotKline'
import './styles/trade-view-layout.scss'

export enum TabType {
  /** 图表 */
  Chart = 'chart',
  /** 订单簿 */
  OrderBook = 'order-book',
  /** 最新成交 */
  RealTimeTransaction = 'real-time-transaction',
}

const TradeView = defineComponent({
  setup() {
    const klineStore = useKlineStore()
    const orderListDividingStore = useOrderListDividingStore()
    const quoteStore = useQuoteStore()
    const responsive = useResponsive()
    const { t } = useI18n()
    const activeTab = ref(TabType.Chart)
    const assetsStore = useAssetsStore()

    watchEffect(() => {
      const symbolName = klineStore.getSpotFullSymbol()
      if (!symbolName) return
      const currentKline = klineStore.currentSpotKline
      if (!currentKline) return
      document.title = `${symbolName} - ${currentKline?.close?.formatNumberWithCommas() || ''}`
    })

    onMounted(async () => {
      quoteStore.listenMarketM()
      assetsStore.fetchData()
    })

    onBeforeUnmount(() => {
      assetsStore.stopFetchData()
    })

    const height = computed(() => {
      if (typeof orderListDividingStore.mainElHeight === 'number') {
        return `${orderListDividingStore.mainElHeight}px`
      }
      return orderListDividingStore.mainElHeight
    })

    const subscribeAll = () => {
      klineStore.subscribeMarket()
      // 订阅盘口
      klineStore.subscribeHandicap()
      // 订阅实时成交
      klineStore.subscribeRealTimeTransaction()
    }

    useChangeSymbol(() => {
      subscribeAll()
    })

    onMounted(() => {
      exchangeSocketService.onReconnect(() => {
        subscribeAll()
      })
    })

    return () => (
      <div class="trade-view-layout">
        <div class="trade-view-top" style={{ height: `${height}` }}>
          {/* <AsideQuoteList /> */}
          <div class="trading-view-container">
            <KlinePanel />
            {!responsive.isMobile && (
              <>
                <div class="kline-container">
                  <SpotKline />
                </div>
              </>
            )}
            {responsive.isMobile && (
              <Tabs tabHeight={42} v-model={activeTab.value}>
                <TabPane name={TabType.Chart} label={t('图表')}>
                  <Visible visible={activeTab.value === TabType.Chart}>
                    <SpotKline />
                  </Visible>
                </TabPane>
                <TabPane name={TabType.OrderBook} label={t('订单簿')}>
                  <Visible visible={activeTab.value === TabType.OrderBook} noVisibleIfRender={false}>
                    <Handicap />
                  </Visible>
                </TabPane>
                <TabPane name={TabType.RealTimeTransaction} label={t('最新成交')}>
                  <Visible visible={activeTab.value === TabType.RealTimeTransaction} noVisibleIfRender={false}>
                    <RealTimeTransaction />
                  </Visible>
                </TabPane>
              </Tabs>
            )}
          </div>
          {!responsive.isMobile && (
            <>
              <SizedBox width={4} />
              <HandicapRealTimeTransaction />
              <SizedBox width={4} />
              <TradeOrderer />
            </>
          )}
        </div>

        <LazyLoadingComponent>
          <OrderList />
        </LazyLoadingComponent>
        {responsive.isMobile && <TradeOrderer />}
      </div>
    )
  },
})

export default TradeView
